import {isNil} from 'lodash';
import {ArrayWithDefault, WithStammdatenIndex} from '@utils-lib';

export abstract class AbstractMapper<S, T> {

  public map(source: S): T {
    if (isNil(source)) {
      return undefined;
    }

    return this.mapInternal(source);
  }

  public mapArray(source: Array<S>): Array<T> {
    if (isNil(source)) {
      return undefined;
    }

    return source.filter(value => !isNil(value)).map(this.mapInternal.bind(this));
  }

  public mapArrayWithDefault(source: Array<S>): ArrayWithDefault<T> {
    if (isNil(source)) {
      return undefined;
    }

    const arrayValue = this.mapArray(source);
    return {
      array: arrayValue,
      standardIndex: this.getMappedArrayDefaultIndex(source)
    };
  }

  public mapArrayWithStammdatenIndex(source: Array<S>): Array<WithStammdatenIndex<T>> {
    if (isNil(source)) {
      return undefined;
    }
    const arrayValue = this.mapArray(source);
    const result: Array<WithStammdatenIndex<T>> = [];
    for (let i = 0; i < arrayValue.length; i++) {
      result.push({
        value: arrayValue[i],
        stammdatenIndex: i
      });
    }
    return result;
  }

  protected getMappedArrayDefaultIndex(source: Array<S>): number {
    return -1;
  }

  protected abstract mapInternal(source: S): T;
}
